import { useCallback } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import { useGetRespondentType } from "@core/CommonDataContext";
import { COMMON_NUM_COL_WIDTH } from "@core/constants";
import { KeywordTableColumn } from "@api/useGetKeywordBaseData";
import { RespondentType } from "@models/RespondentType";

export function useGetRespondentRawTableCell (
    data: Array<{
        columns: Map<RespondentType, KeywordTableColumn<RespondentType>>;
    }>,
) {
    const getRespondentType = useGetRespondentType();

    return useCallback(
        (respTypeId: RespondentType, keySuffix = 'raw'): TableColumn => {
            const respondentType = getRespondentType(respTypeId);

            return {
                key: `resp-type-${respondentType?.id}-${keySuffix}`,
                head: respondentType?.name ?? '',
                headText: respondentType?.name ?? '',
                Value: ({ index }) => <>
                    {data[index].columns.get(respTypeId)?.tableValue ?? ''}
                </>,
                valueText: (index) => data[index].columns.get(respTypeId)?.copyTableValue ?? '',
                style: {
                    cell: {
                        flex: `0 0 ${COMMON_NUM_COL_WIDTH}`,
                        justifyContent: "center",
                        textAlign: "center",
                    }
                }
            };
        },
        [data, getRespondentType]
    );
}